import { API, graphqlOperation } from "aws-amplify";

import { captureError } from "@/sentry";
import { safeJsonStringify } from "@/utils/json";

interface GraphQLResponse {
  data?: any;
  errors: Array<{
    message: string;
    path?: string[];
    errorType?: string;
    errorInfo?: any;
    locations?: Array<{
      line: number;
      column: number;
      sourceName?: string | null;
    }>;
  }>;
}

const customGraphQL = async <T>(
  query: string,
  variables: {} = {}
): Promise<T> => {
  try {
    const response = (await API.graphql(
      graphqlOperation(query, variables)
    )) as GraphQLResponse;
    return response.data!;
  } catch (error) {
    const graphQLError = error as GraphQLResponse;
    // currently let's just console.log the errors.
    // we only want to catch errors that are unexpected / crashes
    console.warn("error", JSON.stringify(error));
    console.warn("customGraphQL", graphQLError?.errors);

    // const ignoredMessages = [
    //   "Object captured as promise rejection with keys: data, errors",
    //   "Error: No current user",
    //   "Failed to fetch",
    // ];

    // if (graphQLError.errors) {
    //   graphQLError.errors.forEach((e) => {
    //     if (ignoredMessages.some((msg) => e.message.includes(msg))) {
    //       // It's an ignored error, do nothing
    //     } else if (e.message.includes("IntentionalError: ")) {
    //       // It's an intentional error, handle accordingly
    //       console.error(e);
    //     } else {
    //       captureError(new Error(e.message), {
    //         extra: {
    //           message: "GraphQL error",
    //           errorInfo: e.errorInfo,
    //           path: e.path,
    //           errorType: e.errorType,
    //         },
    //       });
    //     }
    //   });
    // } else {
    //   const errorMessage = (error as any)?.message || "Unknown Error";
    //   if (!ignoredMessages.some((msg) => errorMessage.includes(msg))) {
    //     captureError(new Error(errorMessage), {
    //       extra: {
    //         message: "GraphQL request error",
    //         errorResponse: safeJsonStringify(error),
    //       },
    //     });
    //   }
    // }
    // Re-throw the error so the calling function can handle it (e.g., show a notification)
    // throw error;
    return null as T;
  }
};

export default customGraphQL;
